<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import DocumentGrid from '../Document/DocumentGrid'
import DocumentUpload from '../Document/DocumentUpload'

export default {
  name: 'UserDocumentsTab',
  components: {
    DocumentGrid,
    DocumentUpload
  },
  mounted () {
    this.$store.commit('documents/updateUploadForm', {field: 'LK_ENTITY_ID', value: 1})
  },
  data () {
    return {
      roleForm: this.$store.state.users.roleForm,
      hideEntity: true
    }
  },
  computed: {
    ...mapState('users', {
      userId: state => state.selectedUser.USER_ID,
      mode: state => state.userModal.mode,
      activeApproval: s => s.activeApproval
    }),
    ...mapState('documents', {
      documentUploadState: s => s.uploadModal.open
    }),
    canDelete(){
      return (this.mode == 'approve' && this.activeApproval.STATUS != 'REJECTED') ? false : true
    }
  }
}
</script>

<template>
  <div class="fit"> 
    <DocumentGrid :entityItemId="userId" :deleteable="canDelete"/>
    <document-upload v-if="documentUploadState" :hideEntity="hideEntity" :entityItemId="userId"/>
  </div>
</template>

<style>
</style>
